function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "pointing_svg__a",
  width: "165.3%",
  height: "155%",
  x: "-32.7%",
  y: "-24.4%",
  filterUnits: "objectBoundingBox"
}, React.createElement("feOffset", {
  dy: 1,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 0.4
}), React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
}), React.createElement("feMerge", null, React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), React.createElement("feMergeNode", {
  in: "SourceGraphic"
}))));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#pointing_svg__a)",
  transform: "translate(9 8)"
}, React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M3.27 12.28c-.28-.36-.63-1.09-1.24-2C1.68 9.78.82 8.83.56 8.34a1.26 1.26 0 01-.15-1 1.32 1.32 0 011.43-1c.51.103.98.353 1.35.72.258.243.496.507.71.79.16.2.2.28.38.51.18.23.3.46.21.12-.07-.5-.19-1.34-.36-2.09-.13-.57-.16-.66-.28-1.09-.12-.43-.19-.79-.32-1.28a14.16 14.16 0 01-.28-1.46A2.82 2.82 0 013.51.71a1.19 1.19 0 011.3-.22c.44.325.77.78.94 1.3a7.73 7.73 0 01.52 2c.16 1 .47 2.46.48 2.76 0-.37-.07-1.15 0-1.5a1.07 1.07 0 01.67-.8 2 2 0 01.92-.06c.31.065.585.243.77.5a5.42 5.42 0 01.38 1.83 6.73 6.73 0 01.28-1.62 1.24 1.24 0 01.69-.48 2.8 2.8 0 011 0c.271.09.508.262.68.49.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 111.9.64v2.26a11.74 11.74 0 01-.24 1.74 5.91 5.91 0 01-.72 1.43 7.21 7.21 0 00-1.19 1.81 4 4 0 00-.1 1c-.001.31.04.62.12.92a5.85 5.85 0 01-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 00-.68 0c-.22.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .18-1-.23-1.36-.41-.36-.83-.78-1.14-1.06l-.84-.96z"
}), React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.75,
  d: "M3.27 12.28c-.28-.36-.63-1.09-1.24-2C1.68 9.78.82 8.83.56 8.34a1.26 1.26 0 01-.15-1 1.32 1.32 0 011.43-1c.51.103.98.353 1.35.72.258.243.496.507.71.79.16.2.2.28.38.51.18.23.3.46.21.12-.07-.5-.19-1.34-.36-2.09-.13-.57-.16-.66-.28-1.09-.12-.43-.19-.79-.32-1.28a14.16 14.16 0 01-.28-1.46A2.82 2.82 0 013.51.71a1.19 1.19 0 011.3-.22c.44.325.77.78.94 1.3a7.73 7.73 0 01.52 2c.16 1 .47 2.46.48 2.76 0-.37-.07-1.15 0-1.5a1.07 1.07 0 01.67-.8 2 2 0 01.92-.06c.31.065.585.243.77.5a5.42 5.42 0 01.38 1.83 6.73 6.73 0 01.28-1.62 1.24 1.24 0 01.69-.48 2.8 2.8 0 011 0c.271.09.508.262.68.49.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 111.9.64v2.26a11.74 11.74 0 01-.24 1.74 5.91 5.91 0 01-.72 1.43 7.21 7.21 0 00-1.19 1.81 4 4 0 00-.1 1c-.001.31.04.62.12.92a5.85 5.85 0 01-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 00-.68 0c-.22.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .18-1-.23-1.36-.41-.36-.83-.78-1.14-1.06l-.84-.96z"
}), React.createElement("path", {
  fill: "#000",
  fillRule: "nonzero",
  d: "M11.75 12.826V9.374a.375.375 0 00-.75 0v3.452a.375.375 0 00.75 0zm-1.98-.001L9.75 9.37a.374.374 0 00-.75.004l.02 3.454a.374.374 0 00.75-.004zM7 9.379l.02 3.446a.376.376 0 10.75-.004l-.02-3.446a.376.376 0 10-.75.004z"
}));

var SvgPointing = function SvgPointing(props) {
  return React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/pointing.659d02ff.svg";
export { SvgPointing as ReactComponent };